module.exports = __webpack_public_path__ + "img/bank_bg.52c10222.png";